
<script>export default {

	data() {
		return {
			class: 'off',
		}
	},

	oncreate() {
		setTimeout(() => this.set({ class: 'on' }), 0)
	},

}

</script>
<div class="loader {{class}}">loading</div>